import React, { PureComponent } from "react";
import ListWidgetContainer from "./dashboard/ListWidgetContainer";
import NumberWidgetContainer from "./dashboard/NumberWidgetContainer";
import { CircleSpinner } from "react-spinners-kit";
import firebase from "firebase/app";
import moment from "moment";

// Add in styles
import "../styles/App.css";

class App extends PureComponent {
  constructor() {
    super();
    this.state = {
      isLoading: true,
      spinner: true,
      array: [],
      thisMonthUsage: 0,
      thisMonthHarvest: 0
    };
  }

  async componentDidMount() {
    let uid = await firebase.auth().currentUser.uid;

    await firebase
      .database()
      .ref("/storage/users")
      .child(uid)
      .child("sensors")
      .once("value")
      .then(snap => {
        snap.forEach(element => {
          let sensorId = element.val().sensorId;
          let sensorName = element.val().sensorName;
          firebase
            .database()
            .ref(`/sensors/${sensorId}/data/twiceAdayLogs`)
            .limitToLast(1)
            .once("value")
            .then(async snap => {
              snap.forEach(element => {
                let logs = element.val();

                let listOfSensorPercentagesObject = {
                  label: sensorName,
                  value: Number(logs.tankPercentage)
                };
                this.setState({
                  array: [...this.state.array, listOfSensorPercentagesObject]
                });
                this.getMonthlyUsage(sensorId);
              });
            })
            .catch(error => {
              console.log(error);
            });
        });
      })
      .then(() => {
        this.setState({ isLoading: false, spinner: false });
      })
      .catch(error => {
        console.log(error);
      });
  }

  getMonthlyUsage = sensorId => {
    firebase
      .database()
      .ref(`/sensors/${sensorId}/data/dailyUsage`)
      .limitToLast(31)
      .once("value")
      .then(async snap => {
        snap.forEach(element => {
          let logs = element.val();

          if (moment(logs.tankTimestamp).isSame(new Date(), "month")) {
            this.setState({
              thisMonthUsage:
                this.state.thisMonthUsage + Number(logs.waterUsage),
              thisMonthHarvest:
                this.state.thisMonthHarvest + Number(logs.waterHarvest)
            });
          }
        });
      })
      .catch(error => {
        console.log(error);
      });
  };

  render() {
    return this.state.isLoading ? (
      <div className="spinner">
        <CircleSpinner size={50} color="#2196F3" loading={this.state.spinner} />
      </div>
    ) : (
      <div className="App">
        <ListWidgetContainer
          value={this.state.array}
          heading="Active Tanks Status"
          rowspan={2}
        />
        <NumberWidgetContainer
          value={this.state.thisMonthUsage.toFixed(0) + " gal"}
          sub={""}
          heading={moment(new Date()).format("MMMM") + " Total Usage"}
          loading={this.state.isLoading}
        />
        <NumberWidgetContainer
          value={this.state.thisMonthHarvest.toFixed(0) + " gal"}
          sub={""}
          heading={moment(new Date()).format("MMMM") + " Total Harvest"}
          loading={this.state.isLoading}
        />
        <NumberWidgetContainer
          value={(this.state.thisMonthUsage.toFixed(0)/moment(new Date()).format("DD")).toFixed(0) + " gal"}
          sub={"per day"}
          heading={moment(new Date()).format("MMMM") + " Average Usage"}
          loading={this.state.isLoading}
        />
      </div>
    );
  }
}
export default App;
